<script>
import ManageAccountsAccountConfigurationEditView from '@/views/Application/Manage/Accounts/Account/Configuration/Edit'

export default {
  extends: ManageAccountsAccountConfigurationEditView,
  data () {
    return {
      breadcrumb: {
        name: 'Configure',
        route: { name: 'sales-opportunities-account-configure', params: this.$route.params }
      }
    }
  }
}
</script>
